import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import React from "react";

import { themeOverrides } from "./themeOverrides";

export const theme = createMuiTheme({
  overrides: {
    ...themeOverrides,
  },
});

export const ChakraUIThemeProviderForMigration = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
